import { CINEMA_NAMES } from 'global/helpers/cinemaList'

export const getCinema = (cinemaId) => {
    const cinema = CINEMA_NAMES.find((cinema) => cinema.id === +cinemaId)
    return cinema ?? null
}

export const getCinemaSlug = (cinemaId) => {
    const cinema = CINEMA_NAMES.find((cinema) => cinema.id === +cinemaId)
    return cinema?.slug ?? null
}
